import { Mapper } from '../../../../base/utils/mapper';

import { ContentResourceModel } from '../../../../domain/models/academy/content-resource.model';

import { ContentResourceEntity } from '../entities/content-resource.entity';

export class ContentResourceImplementationRepositoryMapper extends Mapper<
  ContentResourceEntity,
  ContentResourceModel
> {
  mapFrom(param: ContentResourceEntity): ContentResourceModel {
    return {
      ...param,
    };
  }

  mapTo(param: ContentResourceModel): ContentResourceEntity {
    return {
      ...param,
    };
  }
}
